// API Configuration
// For local development, use relative URLs (proxy will handle routing to backend)
// For production, use the environment variable or fallback to production API
// In local dev, use empty string to leverage proxy, or explicit localhost URL
const resolveApiBaseUrl = (): string => {
  const explicitUrl = process.env.REACT_APP_API_URL;
  if (explicitUrl !== undefined && explicitUrl.trim() !== '') {
    return explicitUrl;
  }

  if (process.env.NODE_ENV === 'development') {
    return '';
  }

  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const isLocalHost = ['localhost', '127.0.0.1', '::1'].includes(hostname);
    if (isLocalHost) {
      const protocol = window.location.protocol || 'http:';
      const port = process.env.REACT_APP_LOCAL_API_PORT?.trim() || '8000';
      return `${protocol}//${hostname}:${port}`;
    }
  }

  return 'https://umbrella-tools-be-0b4dc5f6b3d8.herokuapp.com';
};

const API_BASE_URL = resolveApiBaseUrl();

export const getApiUrl = (endpoint: string) => {
  return `${API_BASE_URL}${endpoint}`;
};

export default {
  API_BASE_URL,
  resolveApiBaseUrl,
  getApiUrl,
};
